import { GetServerSideProps } from "next";
import createServerContext from "../context/server-context";
import { countItems, findItems, getItemFacets } from "../data/db";
import ContentGrid, { Props } from "./content-grid";
import {
  getFiltersFromQuery,
  hasTagFilter,
  toStrippedArray
} from "../api-utils/item-filters";
import { ensureAllowedSort } from "../components/search/shared";
import { getContentLandingPageFields } from "./api/content";
import { setCacheHeader } from "../page-cache";

export default ContentGrid;

export const getServerSideProps: GetServerSideProps<Props> = async (
  baseCtx
) => {
  const ctx = createServerContext(baseCtx);
  const filters = getFiltersFromQuery(baseCtx.query);
  const sort = ensureAllowedSort(toStrippedArray(baseCtx.query.sort)[0]);
  /**
   * Get the filtered content...
   */
  if (hasTagFilter(filters) || sort) {
    const [items, facets, { totalItems, pages }] = await Promise.all([
      findItems(ctx, filters, sort),
      getItemFacets(ctx),
      countItems(ctx, filters)
    ]);

    setCacheHeader(ctx, baseCtx.res);

    return {
      props: {
        fallbackToCurated: true,
        facets,
        filters,
        data: {
          items,
          totalItems,
          pages
        }
      }
    };
  } else {
    /**
     * Get the curated content...
     */
    const [facets, landingFields] = await Promise.all([
      getItemFacets(ctx),
      getContentLandingPageFields(ctx)
    ]);

    setCacheHeader(ctx, baseCtx.res);

    return {
      props: {
        fallbackToCurated: true,
        facets,
        filters,
        data: {
          landingFields
        }
      }
    };
  }
};
